export const USER_PREFERENCES = {
	SIDENAV_PINNED: 'sidenav_pinned',
	NAV_SHORTCUTS: 'nav_shortcuts',
	LAST_SEEN_CHANGELOG_VERSION: 'last_seen_changelog_version',
	SPAN_DETAILS_PINNED_ATTRIBUTES: 'span_details_pinned_attributes',
	SPAN_DETAILS_PREVIEW_ATTRIBUTES: 'span_details_preview_attributes',
	SPAN_DETAILS_COLOR_BY_ATTRIBUTE: 'span_details_color_by_attribute',
	SPAN_PERCENTILE_RESOURCE_ATTRIBUTES: 'span_percentile_resource_attributes',
};
